import { render, staticRenderFns } from "./RecordEditorCreateDialog.vue?vue&type=template&id=10289ae8&scoped=true&"
import script from "./RecordEditorCreateDialog.vue?vue&type=script&lang=js&"
export * from "./RecordEditorCreateDialog.vue?vue&type=script&lang=js&"
import style0 from "./RecordEditorCreateDialog.vue?vue&type=style&index=0&id=10289ae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10289ae8",
  null
  
)

export default component.exports